import * as React from "react";
import { useState } from "react";
import styled from "styled-components";
import { Button } from "components/bootstrap";
import SuggestionRow from "./SuggestionRow";
import useEventDefinitionSuggestions from "../hooks/useEventDefinitionSuggestions";
const Wrapper = styled.div`
  border-left: 3px solid ${({ theme }) => theme.colors.variant.light.info};
  padding: ${({ theme }) => `${theme.spacings.xs} ${theme.spacings.sm}`};
  margin: ${({ theme }) => `${theme.spacings.sm} 0`};
  background: ${({ theme }) => theme.colors.variant.lightest.info};
`;
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacings.xs};
`;
const Summary = styled.p`
  font-style: italic;
  opacity: 0.85;
  margin: ${({ theme }) => `0 0 ${theme.spacings.xs}`};
  padding-left: ${({ theme }) => theme.spacings.xs};
  border-left: 2px solid ${({ theme }) => theme.colors.cards.border};
`;
const SuggestionsDetailPanel = ({ eventDefinition }) => {
  const [showAll, setShowAll] = useState(false);
  const { data, isLoading } = useEventDefinitionSuggestions(showAll ? "all" : "suggested");
  if (isLoading || !data) return null;
  const group = data.groups.find((g) => g.event_definition_id === eventDefinition.id);
  if (!group || group.suggestions.length === 0) return null;
  return /* @__PURE__ */ React.createElement(Wrapper, { "data-testid": "suggestions-detail-panel" }, /* @__PURE__ */ React.createElement(Header, null, /* @__PURE__ */ React.createElement("strong", null, "Tuning suggestions for this event definition"), /* @__PURE__ */ React.createElement(Button, { bsSize: "xsmall", onClick: () => setShowAll(!showAll) }, showAll ? "Hide dismissed & applied" : "Show dismissed & applied")), data.summary && /* @__PURE__ */ React.createElement(Summary, { "data-testid": "suggestions-detail-summary" }, data.summary), group.suggestions.map((s) => /* @__PURE__ */ React.createElement(SuggestionRow, { key: s.id, suggestion: s })));
};
export default SuggestionsDetailPanel;
